import React, { Component } from 'react';
import axios from 'axios';
import { NavLink, Navigate } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  TablePagination,
  TextField,
  Card,
  CardContent,
  CardActions, IconButton
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Serverurl from './Apiurl';
import CardActionArea from '@mui/material/CardActionArea';
import Fab from '@mui/material/Fab';
import AddCustomer from "./AddCustomer";
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";



class Quotecustomers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      totalItems: 0,
      page: 0,
      rowsPerPage: 5,
      confirmDialogVisible: false,
      deletingCustomer: null,
      itemsPerPageOptions: [5, 10, 25, 50],
      logredirect: false,
      pagename: '',
      searchName: '',addCustomerOpen: false,
    };
  }

  componentDidMount() {
    this.fetchCustomers();
  }

  handleSearchChange = (e) => {
    this.setState({ searchName: e.target.value });
  };

  fetchCustomers = () => {
	   const bu_id = localStorage.getItem("GBuserid");
    axios
      .get(
        Serverurl +
          "ajaxcustomer.php?action=getall&StartIndex=" +
          this.state.page +
          "&PageSize=" +
          this.state.rowsPerPage +
          "&cu_name=" +
          this.state.searchName+
      "&cu_bu_id=" + bu_id  
      )
      .then((res) => {
        const totalItems = parseInt(res.data[0]?.total || 0);
        this.setState({ customers: res.data, totalItems });
      });
  };

  onPageChange = (event, newPage) => {
    this.setState({ page: newPage }, this.fetchCustomers);
  };

  onRowsPerPageChange = (event) => {
    this.setState(
      { rowsPerPage: parseInt(event.target.value, 10), page: 0 },
      this.fetchCustomers
    );
  };

  searchCustomers = () => {
    this.setState({ page: 0 }, this.fetchCustomers);
  };

  openConfirmDeleteDialog = (id) => {
    this.setState({ confirmDialogVisible: true, deletingCustomer: id });
  };

  confirmDelete = () => {
    const { deletingCustomer } = this.state;

    const formData = new FormData();
    formData.append('action', 'delete');
    formData.append('cu_id', deletingCustomer);
    formData.append('userid', 1);

    axios.post(Serverurl + "ajaxcustomer.php", formData).then(() => {
      this.setState({ confirmDialogVisible: false, deletingCustomer: null });
      this.fetchCustomers();
    });
  };

  render() {
    if (this.state.logredirect) {
      return <Navigate to={this.state.pagename} />;
    }

    return (
      <div className="formdisplay">
       
       
 <Box
  sx={{
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    mb: 2,
    whiteSpace: "nowrap",
	
  }}
>
      <ChevronLeftIcon
  className="global-back-arrow"
  onClick={() => window.history.back()}
/>

  <Typography variant="h4" sx={{ m: 0 }}>
    Customer
  </Typography>
</Box>


        
		
		 <Box sx={{ display: 'flex', flexDirection: 'column', mb: 3}}>
 
  <Box sx={{ display: 'flex' }}>
    <TextField
      variant="outlined"
      value={this.state.searchName}
      onChange={this.handleSearchChange}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          this.searchCustomers();
        }
      }}
      size="small"
      fullWidth
   placeholder="Search by Name / Phone / Email"
    sx={{
 
      borderRadius: '50px',
      '& .MuiOutlinedInput-root': {
        borderRadius: '50px',
		border: '0.5px solid #c0c0c0',
		padding: '3px 0px !important',
        paddingRight: '4px',
        '& fieldset': {
          borderColor: '#e2e8f0',
        },
        '&:hover fieldset': {
          borderColor: '#cbd5e1 !important',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#11408f !important',
        },
      },
      '& .MuiOutlinedInput-input': {
        paddingLeft: '20px !important',
        fontSize: '14px',
      },
    }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={this.searchCustomers}
 sx={{
              backgroundColor: '#11408f',
              color: '#ffffff',
			  width: '56px',
			  marginRight: '0px',
			  
              padding: '11px',
              '&:hover': {
                backgroundColor: '#0d3476',
              },
            }}			edge="end">
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  </Box>
</Box>

        
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {this.state.customers.length > 0 ? (
            this.state.customers.map((item) => (
              <li key={item.cu_id} style={{ marginBottom: 16 }}>
                <Card elevation={3}>
				<CardActionArea   onClick={() => this.props.onSelectCustomer(item)}>
                  <CardContent>
                    <Typography variant="h6">{item.cu_name}</Typography>

                    <Typography variant="body2" color="text.secondary">
                      {item.cu_companyname}
                    </Typography>

                    <Typography variant="body2" sx={{ mt: 1 }}>
                      <strong>Phone:</strong> {item.cu_phoneno} <br />
                     
                    </Typography>

                  </CardContent>
				  </CardActionArea>



                 
                </Card>
              </li>
            ))
          ) : (
            <Typography align="center">No customers found</Typography>
          )}
        </ul>

       {this.state.totalItems > 0 && (
        <TablePagination
          component="div"
          count={this.state.totalItems}
          page={this.state.page}
          onPageChange={this.onPageChange}
          rowsPerPage={this.state.rowsPerPage}
          onRowsPerPageChange={this.onRowsPerPageChange}
          rowsPerPageOptions={this.state.itemsPerPageOptions}
        />
		)}

       {/* Floating Add Button */}

 <Fab
  onClick={() => this.setState({ addCustomerOpen: true })}
  sx={{
    position: 'fixed',
    bottom: 30,
    right: 30,
    zIndex: 1000,
    backgroundColor: '#11408f',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#0d3476',
    },
  }}
>
    Add
  </Fab>

        <Dialog
          open={this.state.confirmDialogVisible}
          onClose={() => this.setState({ confirmDialogVisible: false })}
        >
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to delete this customer?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ confirmDialogVisible: false })}>
              Cancel
            </Button>
            <Button onClick={this.confirmDelete} color="error" variant="contained">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
		
		<Dialog
  open={this.state.addCustomerOpen}
  onClose={() => this.setState({addCustomerOpen:false})}
  fullWidth
  maxWidth="md" sx={{padding:'10px 5px'}}
>
   

  <DialogContent>

    <AddCustomer
      quotationMode={true}
      onCustomerAdded={(customer)=>{

        this.setState({
          addCustomerOpen:false
        });

        this.props.onSelectCustomer(customer);

      }}
    />

  </DialogContent>

</Dialog>
      </div>
    );
  }
}

export default Quotecustomers;
